import React, { useState, useEffect } from 'react';
import { Search, Download, CheckCircle, MapPin, Clock, CalendarPlus, FileText, RefreshCcw, CheckSquare, ArrowLeft, MessageCircle, UserX } from 'lucide-react';
import * as XLSX from 'xlsx';
import { perfilNoModulo } from '../../../utils/perfisDerivados';

const ProcessoSeletivoAprovados = () => {
    const [candidatos, setCandidatos] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [filterNome, setFilterNome] = useState('');
    
    const [subAbaAtiva, setSubAbaAtiva] = useState('pendentes');

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isRemarcacao] = useState(false);
    const [modalMode, setModalMode] = useState(''); 
    const [candSelecionado, setCandSelecionado] = useState(null);
    const [integracaoData, setIntegracaoData] = useState({ data_integracao: '', data_inicio: '', hora_inicio: '', endereco: '', loja: '' });

    const userStr = localStorage.getItem('user');
    const user = userStr ? JSON.parse(userStr) : {};
    const role = perfilNoModulo(user.perfil, 'processoseletivo');
    const canAction = role === 'Admin' || role === 'RH' || role === 'Diretoria' || role === 'ProcessoSeletivo';

    // Estado para a Super Pop-up de Automação
    const [automacaoModal, setAutomacaoModal] = useState({
        isOpen: false,
        titulo: '',
        mensagem: '',
        onConfirm: null,
        onCancel: null
    });

    // Filtros
    const [filterCpf, setFilterCpf] = useState('');
    const [filterVaga, setFilterVaga] = useState('');
    const [filterLoja, setFilterLoja] = useState('');
    const [filterStatus, setFilterStatus] = useState('');

    // Paginação (50 por página)
    const [paginaAtual, setPaginaAtual] = useState(1);
    const ITENS_POR_PAGINA = 50;

    // Listas dinâmicas
    const vagasDisponiveis = [...new Set(candidatos.map(c => c.CARGO).filter(Boolean))].sort();
    const lojasDisponiveis = [...new Set(candidatos.map(c => c.LOJA_ATUACAO).filter(Boolean))].sort();
    

    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = localStorage.getItem('authToken');
                const response = await fetch('/api/processo-seletivo/candidatos', { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` } });
                if (!response.ok) throw new Error("Erro ao carregar os dados.");
                setCandidatos(await response.json());
                setIsLoading(false);
            } catch (err) { setError(err.message); setIsLoading(false); }
        };
        fetchData();
    }, []);

    // Troca de sub-aba ou de qualquer filtro volta para a 1ª página.
    useEffect(() => { setPaginaAtual(1); }, [subAbaAtiva, filterNome, filterCpf, filterVaga, filterLoja, filterStatus]);

    // A MÁGICA: O filtro agora puxa o Status 6 E o Status 4!
    const processosAguardando = candidatos.filter(c => c.STATUS_ETAPA === 6 || c.STATUS_ETAPA === 4);
    const processosAgendados = candidatos.filter(c => c.STATUS_ETAPA === 7);
    
    const listaAtual = subAbaAtiva === 'pendentes' ? processosAguardando : processosAgendados;
    const aprovados = listaAtual.filter(cand => {
        // 1. Nome e CPF
        const matchNome = cand.NOME_COMPLETO?.toLowerCase().includes(filterNome.toLowerCase());
        const cpfLimpo = cand.CPF ? String(cand.CPF).replace(/\D/g, '') : '';
        const matchCpf = cpfLimpo.includes(filterCpf);
        
        // 2. Vaga e Loja
        const matchVaga = filterVaga === '' || cand.CARGO === filterVaga;
        const matchLoja = filterLoja === '' || cand.LOJA_ATUACAO === filterLoja;

        // 3. Status (Recriando a regra que você usa na renderização da tabela)
        let statusCand = 'Aguardando Início';
        if (cand.STATUS_ETAPA === 7) statusCand = 'Processo Finalizado';
        else if (cand.MOTIVO_REPROVACAO === 'REMARCADO') statusCand = 'Remarcado (Falta)';
        else if (cand.STATUS_ETAPA === 4) statusCand = 'No Médico (Exame)';

        const matchStatus = filterStatus === '' || statusCand === filterStatus;

        // Retorna apenas se passar em TODAS as validações
        return matchNome && matchCpf && matchVaga && matchLoja && matchStatus;
    });

    // Recorte da página atual (50 por vez)
    const totalPaginas = Math.ceil(aprovados.length / ITENS_POR_PAGINA);
    const indexPrimeiro = (paginaAtual - 1) * ITENS_POR_PAGINA;
    const aprovadosPaginados = aprovados.slice(indexPrimeiro, indexPrimeiro + ITENS_POR_PAGINA);

    const getEnderecoLoja = (loja) => {
        switch(loja) {
            case 'ANV': return 'Av. Desembargador dos Santos Neves, 1430 - Enseada do Suá, Vitória - ES, 29065-730';
            case 'BVV': return 'Boulevard Shopping Vila Velha - Rod. do Sol, 5000 - Jockey de Itaparica, Vila Velha - ES, 29103-800';
            case 'FER': return 'R. Des. Vicente Caetano, 115 - Mata da Praia, Vitória - ES, 29065-730';
            case 'GTV': return 'Avenida Governador, Rod. Jones dos Santos Neves, 47 - Varzea Nova, Guarapari - ES, 29213-506';
            case 'MAL': return 'Shopping Mestre Álvaro - Av. João Palácio, 300 - Lj 102 -Piso 1 - Eurico Salles, Serra - ES, 29160-161';
            case 'MOX': return 'Shopping Moxuara - BR-262, 6555 - lj. 314 - A/B/C - piso L3 - Campo Grande, Cariacica - ES, 29145-606';
            case 'PCI': return 'Av. Princesa Isabel, 287 - Centro, Vitória - ES, 29010-361';
            case 'PCS': return 'Shopping Praia da Costa - Av. Dr. Olivio Lira, 353 - Praia da Costa, Vila Velha - ES, 29101-950';
            case 'RDP': return 'R. Constante Sodré, 777 - Barro Vermelho, Vitória - ES, 29057-545';
            case 'SED': return 'Av. Eldes Scherrer Souza, S/N - Parque Res. Laranjeiras, Serra - ES, 29167-080';
            case 'SVV': return 'Shopping Vila Velha - Av. Luciano das Neves, 2418 - Divino Espírito Santo, Vila Velha - ES, 29107-900';
            case 'VEL': return 'Av. Champagnat, 911 - Centro de Vila Velha, Vila Velha - ES, 29100-013';
            case 'VSH': return 'Shopping Vitória - Av. Américo Buaiz, 200 - Enseada do Suá, Vitória - ES, 29050-902';
            default: return '';
        }
    };

    const formatarDataInput = (dateObj) => { return `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, '0')}-${String(dateObj.getDate()).padStart(2, '0')}`; };

    const calcularDatas = (candidato) => {
        const { FOLGA, ESCALA, HORARIO, LOCAL_ENTREVISTA } = candidato;
        const isFluxoFERMOX = ['FER', 'MOX'].includes(LOCAL_ENTREVISTA);

        let dataIntegracao = new Date();
        dataIntegracao.setHours(12, 0, 0, 0); 
        let diasAteIntegracao = isFluxoFERMOX ? (3 - dataIntegracao.getDay() + 7) % 7 : (5 - dataIntegracao.getDay() + 7) % 7; 
        if (diasAteIntegracao === 0) diasAteIntegracao = 7;
        dataIntegracao.setDate(dataIntegracao.getDate() + diasAteIntegracao);

        let dataInicio = new Date(dataIntegracao);
        dataInicio.setDate(dataInicio.getDate() + (isFluxoFERMOX ? 1 : 3)); 

        if (FOLGA) {
            const f = String(FOLGA).toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").trim();
            const e = ESCALA ? String(ESCALA).toUpperCase().trim() : '';

            if (e.includes('12X36') || f.includes('PAR') || f.includes('IMPAR')) {
                const diaDoMes = dataInicio.getDate();
                const isDiaPar = (diaDoMes % 2 === 0);
                const folgaPar = f === 'PAR' || f.includes(' PAR') || f === 'PAR ';
                const folgaImpar = f === 'IMPAR' || f.includes(' IMPAR') || f === 'IMPAR ';
                if ((folgaPar && isDiaPar) || (folgaImpar && !isDiaPar)) dataInicio.setDate(dataInicio.getDate() + 1);
            } else {
                if (isFluxoFERMOX) {
                    if (f.includes('QUI')) dataInicio.setDate(dataInicio.getDate() + 1); 
                } else {
                    if (f.includes('SEG') && f.includes('TER')) dataInicio.setDate(dataInicio.getDate() + 2); 
                    else if (f.includes('SEG')) dataInicio.setDate(dataInicio.getDate() + 1); 
                }
            }
        }

        return {
            dataIntegracao: formatarDataInput(dataIntegracao),
            dataInicio: formatarDataInput(dataInicio),
            horaChegada: HORARIO ? String(HORARIO).substring(0, 5) : '',
            diaSemanaIntegracao: isFluxoFERMOX ? 'Quarta-feira' : 'Sexta-feira'
        };
    };

    const abrirModal = (candidato, tipo) => {
        setCandSelecionado(candidato);
        setModalMode(tipo);
        
        const calculo = calcularDatas(candidato);
        setIntegracaoData({
            data_integracao: calculo.dataIntegracao,
            data_inicio: calculo.dataInicio,
            hora_inicio: calculo.horaChegada,
            endereco: getEnderecoLoja(candidato.LOJA_ATUACAO),
            loja: candidato.LOJA_ATUACAO || '',
            diaSemanaIntegracao: calculo.diaSemanaIntegracao
        });
        setIsModalOpen(true);
    };

    const handleSalvarModal = async () => {
        const token = localStorage.getItem('authToken');
        
        if (modalMode === 'remarcar') {
            if (!integracaoData.data_integracao) return alert("Por favor, preencha a Nova Data da Integração.");
            
            // Função interna do Backend para Remarcação
            const executarRemarcacao = async (enviarMensagem) => {
                setAutomacaoModal({ ...automacaoModal, isOpen: false });

                try {
                    const response = await fetch('/api/processo-seletivo/remarcar-integracao-email', {
                        method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                        body: JSON.stringify({ 
                            idCandidato: candSelecionado.ID, 
                            data_integracao: integracaoData.data_integracao,
                            enviar_automacao: enviarMensagem
                        })
                    });
                    if (!response.ok) throw new Error("Erro no servidor.");
                    alert(enviarMensagem ? "Sucesso! E-mail de remarcação enviado." : "Remarcação salva silenciosamente.");
                    setIsModalOpen(false);
                    setCandidatos(prev => prev.map(c => c.ID === candSelecionado.ID ? { ...c, MOTIVO_REPROVACAO: 'REMARCADO' } : c));
                } catch (error) { alert("Erro ao remarcar: " + error.message); }
            };

            // Abre o Super Modal para Remarcação
            setAutomacaoModal({
                isOpen: true,
                titulo: 'Avisar sobre Remarcação? 🔄',
                mensagem: `Deseja enviar o E-MAIL automático avisando ${candSelecionado.NOME_COMPLETO.split(' ')[0]} sobre a nova data de integração?`,
                onConfirm: () => executarRemarcacao(true),
                onCancel: () => executarRemarcacao(false)
            });

        } 
        else {
            if (!integracaoData.loja) return alert("Por favor, selecione a Loja de Atuação do candidato.");
            if (!integracaoData.data_inicio || !integracaoData.hora_inicio || !integracaoData.endereco) return alert("Por favor, preencha todos os campos da loja.");
            
            // Função interna do Backend para Finalização
            const executarFinalizacao = async (enviarMensagem) => {
                setAutomacaoModal({ ...automacaoModal, isOpen: false });

                try {
                    const response = await fetch('/api/processo-seletivo/concluir-integracao', {
                        method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                        body: JSON.stringify({
                            idCandidato: candSelecionado.ID, data_inicio: integracaoData.data_inicio,
                            hora_inicio: integracaoData.hora_inicio, endereco: integracaoData.endereco,
                            loja_atuacao: integracaoData.loja || null,
                            isRemarcacao: isRemarcacao,
                            enviar_automacao: enviarMensagem
                        })
                    });
                    if (!response.ok) throw new Error("Erro no servidor.");
                    alert(enviarMensagem ? "Processo finalizado e E-mail de 1º dia enviado!" : "Processo finalizado silenciosamente no sistema.");
                    setIsModalOpen(false);
                    setCandidatos(prev => prev.map(c => c.ID === candSelecionado.ID ? { ...c, STATUS_ETAPA: 7, MOTIVO_REPROVACAO: null } : c));
                } catch (error) { alert("Erro ao finalizar processo: " + error.message); }
            };

            // Abre o Super Modal para Finalização
            setAutomacaoModal({
                isOpen: true,
                titulo: 'Finalizar e Enviar E-mail? 🎉',
                mensagem: `A integração foi concluída? Deseja finalizar o processo e enviar o E-MAIL de boas-vindas com os dados do 1º dia na loja para ${candSelecionado.NOME_COMPLETO.split(' ')[0]}?`,
                onConfirm: () => executarFinalizacao(true),
                onCancel: () => executarFinalizacao(false)
            });
        }
    };

    const handleDesfazerFinalizacao = async (idCandidato) => {
        if (!window.confirm("Deseja retornar este candidato para a aba de 'Aguardando Início'?")) return;
        try {
            const token = localStorage.getItem('authToken');
            await fetch('/api/processo-seletivo/retornar-integracao', { 
                method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify({ idCandidato }) 
            });
            setCandidatos(prev => prev.map(c => c.ID === idCandidato ? {...c, STATUS_ETAPA: 6} : c));
        } catch (error) { alert("Erro ao retornar o candidato."); }
    };

    

    // Registrar desistência: o candidato apto desistiu antes de iniciar.
    // Backend (/registrar-desistencia) grava o funil em status 8 (Desistente) e
    // sincroniza a inscrição por CPF (dtbInscricao -> status 3). Ao virar status 8
    // ele sai das filas 6/4/7 desta tela e passa a aparecer no Banco de Talentos.
    const handleRegistrarDesistencia = async (cand) => {
        if (!window.confirm(`Confirmar DESISTÊNCIA de ${cand.NOME_COMPLETO}?\n\nO candidato sai desta tela e vai para o Banco de Talentos como Desistente.`)) return;
        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch('/api/processo-seletivo/registrar-desistencia', {
                method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({ idCandidato: cand.ID })
            });
            if (!response.ok) throw new Error("Erro no servidor.");
            setCandidatos(prev => prev.map(c => c.ID === cand.ID ? { ...c, STATUS_ETAPA: 8 } : c));
        } catch (error) { alert("Erro ao registrar desistência: " + error.message); }
    };

    const exportarExcel = () => {
        const dataToExport = aprovados.map(cand => ({
            'Nome Completo': cand.NOME_COMPLETO,
            'CPF': cand.CPF.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4"),
            'Celular': cand.CELULAR,
            'Cargo Aprovado': cand.CARGO || 'Não informado',
            'Loja de Atuação': cand.LOJA_ATUACAO || 'Não informada',
            'Escala': `${cand.ESCALA} - ${cand.HORARIO}`,
            'Folga': cand.FOLGA || 'Não definida',
            'Status': cand.STATUS_ETAPA === 7 ? 'Processo Finalizado' : (cand.MOTIVO_REPROVACAO === 'REMARCADO' ? 'Remarcado (Falta)' : (cand.STATUS_ETAPA === 4 ? 'No Médico (Exame)' : 'Aguardando Início'))
        }));
        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Integracao");
        XLSX.writeFile(workbook, `Controle_Integracao.xlsx`);
    };

    const inputStyleModal = { width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1', outline: 'none', fontWeight: '600', color: '#0f172a', fontSize: '14px' };
    const labelStyleModal = { display: 'block', fontSize: '12px', fontWeight: '800', color: '#475569', marginBottom: '6px', textTransform: 'uppercase' };

    if (isLoading) return <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>Carregando dados...</div>;
    if (error) return <div style={{ padding: '24px', textAlign: 'center', color: '#e11d48' }}>{error}</div>;

    return (
        <div style={{ animation: 'fadeIn 0.3s ease-in-out' }}>
            <div style={{ marginBottom: '24px' }}>
                <h2 style={{ fontSize: '24px', fontWeight: '900', color: '#0f172a', marginBottom: '8px', margin: 0 }}>Integração/Aprovados</h2>
                <p style={{ color: '#64748b', fontSize: '15px', margin: 0 }}>Candidatos aptos no exame médico. Defina a data e a loja de início para finalizar o processo.</p>
            </div>

            <div style={{ display: 'flex', gap: '12px', marginBottom: '24px' }}>
                <button onClick={() => setSubAbaAtiva('pendentes')} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '12px 24px', borderRadius: '8px', fontWeight: '800', cursor: 'pointer', transition: 'all 0.2s', border: 'none', backgroundColor: subAbaAtiva === 'pendentes' ? '#e11d48' : '#fff', color: subAbaAtiva === 'pendentes' ? '#fff' : '#64748b', boxShadow: subAbaAtiva === 'pendentes' ? '0 4px 6px rgba(225, 29, 72, 0.2)' : '0 1px 3px rgba(0,0,0,0.05)' }}>
                    <CalendarPlus size={18} /> 1. Aguardando Início ({processosAguardando.length})
                </button>
                <button onClick={() => setSubAbaAtiva('agendados')} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '12px 24px', borderRadius: '8px', fontWeight: '800', cursor: 'pointer', transition: 'all 0.2s', border: 'none', backgroundColor: subAbaAtiva === 'agendados' ? '#e11d48' : '#fff', color: subAbaAtiva === 'agendados' ? '#fff' : '#64748b', boxShadow: subAbaAtiva === 'agendados' ? '0 4px 6px rgba(225, 29, 72, 0.2)' : '0 1px 3px rgba(0,0,0,0.05)' }}>
                    <CheckSquare size={18} /> 2. Processos Finalizados ({processosAgendados.length})
                </button>
            </div>

            <div style={{ backgroundColor: '#fff', borderRadius: '12px', padding: '20px', border: '1px solid #e2e8f0', marginBottom: '32px', display: 'flex', gap: '16px', alignItems: 'flex-end', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                <div style={{ flex: '1 1 200px' }}>
                    <label style={{ display: 'block', fontSize: '12px', fontWeight: '800', color: '#475569', textTransform: 'uppercase', marginBottom: '8px' }}>Nome Completo</label>
                    <div style={{ position: 'relative' }}>
                        <Search size={16} color="#94a3b8" style={{ position: 'absolute', left: '12px', top: '12px' }} />
                        <input type="text" placeholder="Buscar por nome..." value={filterNome} onChange={(e) => setFilterNome(e.target.value)} style={{ width: '100%', padding: '10px 10px 10px 36px', borderRadius: '8px', border: '1px solid #cbd5e1', outline: 'none' }} />
                    </div>
                </div>
                <div style={{ flex: '1 1 200px' }}>
                        <label style={{ display: 'block', fontSize: '12px', fontWeight: '800', color: '#475569', textTransform: 'uppercase', marginBottom: '8px' }}>CPF</label>
                        <div style={{ position: 'relative' }}>
                        <Search size={16} color="#94a3b8" style={{ position: 'absolute', left: '12px', top: '12px' }} />
                        <input type="text" placeholder="Apenas números..." value={filterCpf} onChange={(e) => setFilterCpf(e.target.value.replace(/\D/g, ''))} style={{ width: '100%', padding: '10px 10px 10px 36px', borderRadius: '8px', border: '1px solid #cbd5e1', outline: 'none' }} />
                    </div>
                </div>
                <div style={{ flex: '1 1 200px' }}>
                    <label style={{ display: 'block', fontSize: '12px', fontWeight: '800', color: '#475569', textTransform: 'uppercase', marginBottom: '8px' }}>Vaga Selecionada</label>
                    <select 
                        value={filterVaga} 
                        onChange={(e) => setFilterVaga(e.target.value)} 
                        style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1', outline: 'none', color: '#475569', cursor: 'pointer', backgroundColor: '#fff' }}
                    >
                        <option value="">Todas as Vagas</option>
                        {vagasDisponiveis.map(vaga => <option key={vaga} value={vaga}>{vaga}</option>)}
                    </select>
                </div>
                {/* Filtro de Status */}
                <div style={{ flex: '1 1 150px' }}>
                    <label style={{ display: 'block', fontSize: '12px', fontWeight: '800', color: '#475569', textTransform: 'uppercase', marginBottom: '8px' }}>Status</label>
                    <select 
                        value={filterStatus} 
                        onChange={(e) => setFilterStatus(e.target.value)} 
                        style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1', outline: 'none', color: '#475569', cursor: 'pointer', backgroundColor: '#fff' }}
                    >
                        <option value="">Todos os Status</option>
                        <option value="Aguardando Início">Aguardando Início</option>
                        <option value="No Médico (Exame)">No Médico (Exame)</option>
                        <option value="Remarcado (Falta)">Remarcado (Falta)</option>
                        <option value="Processo Finalizado">Processo Finalizado</option>
                    </select>
                </div>
                <div style={{ flex: '1 1 150px' }}>
                    <label style={{ display: 'block', fontSize: '12px', fontWeight: '800', color: '#475569', textTransform: 'uppercase', marginBottom: '8px' }}>Loja</label>
                    <select 
                        value={filterLoja} 
                        onChange={(e) => setFilterLoja(e.target.value)} 
                        style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1', outline: 'none', color: '#475569', cursor: 'pointer', backgroundColor: '#fff' }}
                    >
                        <option value="">Todas as Lojas</option>
                        {lojasDisponiveis.map(loja => <option key={loja} value={loja}>{loja}</option>)}
                    </select>
                </div>
                <button onClick={exportarExcel} style={{ backgroundColor: '#10b981', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '8px', fontWeight: '800', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', height: '40px' }}><Download size={18} /> Exportar</button>
            </div>

            <div style={{ backgroundColor: '#fff', borderRadius: '16px', border: '1px solid #e2e8f0', overflow: 'hidden', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                        <thead>
                            <tr style={{ backgroundColor: '#f8fafc', borderBottom: '2px solid #e11d48' }}>
                                <th style={{ padding: '16px 24px', color: '#475569', fontSize: '13px', fontWeight: '800', whiteSpace: 'nowrap' }}>Nome e Contato</th>
                                <th style={{ padding: '16px 24px', color: '#475569', fontSize: '13px', fontWeight: '800', whiteSpace: 'nowrap' }}>CPF</th>
                                <th style={{ padding: '16px 24px', color: '#475569', fontSize: '13px', fontWeight: '800', whiteSpace: 'nowrap' }}>Vaga (Cargo)</th>
                                <th style={{ padding: '16px 24px', color: '#475569', fontSize: '13px', fontWeight: '800', whiteSpace: 'nowrap' }}>Loja / Escala</th>
                                <th style={{ padding: '16px 24px', color: '#475569', fontSize: '13px', fontWeight: '800', whiteSpace: 'nowrap', textAlign: 'center' }}>Status</th>
                                {canAction && <th style={{ padding: '16px 24px', color: '#475569', fontSize: '13px', fontWeight: '800', whiteSpace: 'nowrap', textAlign: 'center' }}>Ação do RH</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {aprovadosPaginados.length > 0 ? aprovadosPaginados.map(cand => (
                                <tr key={cand.ID} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                    <td style={{ padding: '16px 24px', whiteSpace: 'nowrap' }}>
                                        <strong style={{ color: '#0f172a', fontSize: '14px' }}>{cand.NOME_COMPLETO}</strong><br/>
                                        <span style={{ color: '#64748b', fontSize: '13px' }}>{cand.CELULAR}</span>
                                    </td>
                                    <td style={{ padding: '16px 24px', color: '#475569', fontSize: '14px', fontFamily: 'monospace', whiteSpace: 'nowrap' }}>{cand.CPF.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")}</td>
                                    <td style={{ padding: '16px 24px', color: '#0f172a', fontSize: '14px', fontWeight: '800', whiteSpace: 'nowrap' }}>{cand.CARGO}</td>
                                    <td style={{ padding: '16px 24px', color: '#475569', fontSize: '13px', whiteSpace: 'nowrap' }}>
                                        <strong style={{ color: '#0f172a' }}>{cand.LOJA_ATUACAO}</strong><br/>
                                        <span>{cand.ESCALA} ({cand.HORARIO})</span>
                                        {cand.FOLGA && <div style={{ fontSize: '12px', marginTop: '2px' }}>Folga: <strong>{cand.FOLGA}</strong></div>}
                                    </td>

                                    {/* Coluna Status (restaurada) — badges semânticos por situação */}
                                    <td style={{ padding: '16px 24px', textAlign: 'center' }}>
                                        {subAbaAtiva === 'pendentes' ? (
                                            cand.MOTIVO_REPROVACAO === 'REMARCADO' ? (
                                                <span style={{ backgroundColor: '#fff1f2', color: '#be123c', padding: '4px 10px', borderRadius: '999px', fontSize: '11px', fontWeight: 800, display: 'inline-flex', alignItems: 'center', gap: '4px', whiteSpace: 'nowrap' }}>
                                                    <RefreshCcw size={12} /> Faltou / Remarcado
                                                </span>
                                            ) : cand.STATUS_ETAPA === 4 ? (
                                                <span style={{ backgroundColor: '#fffbeb', color: '#b45309', padding: '4px 10px', borderRadius: '999px', fontSize: '11px', fontWeight: 800, display: 'inline-flex', alignItems: 'center', gap: '4px', whiteSpace: 'nowrap' }}>
                                                    <Clock size={12} /> Exame Pendente
                                                </span>
                                            ) : (
                                                <span style={{ backgroundColor: '#eff6ff', color: '#1d4ed8', padding: '4px 10px', borderRadius: '999px', fontSize: '11px', fontWeight: 800, display: 'inline-flex', alignItems: 'center', gap: '4px', whiteSpace: 'nowrap' }}>
                                                    <CalendarPlus size={12} /> Aguardando Início
                                                </span>
                                            )
                                        ) : (
                                            <span style={{ backgroundColor: '#ecfdf5', color: '#047857', padding: '4px 10px', borderRadius: '999px', fontSize: '11px', fontWeight: 800, display: 'inline-flex', alignItems: 'center', gap: '4px', whiteSpace: 'nowrap' }}>
                                                <CheckCircle size={12} /> Finalizado
                                            </span>
                                        )}
                                    </td>

                                    {canAction && (
                                        <td style={{ padding: '16px 24px', textAlign: 'center', verticalAlign: 'middle' }}>
                                            {subAbaAtiva === 'pendentes' ? (
                                                <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', alignItems: 'center' }}>
                                                    {/* Ação principal: ícone sólido */}
                                                    <button onClick={() => abrirModal(cand, 'finalizar')} title="Finalizar processo (agendar 1º dia na loja)" style={{ width: '36px', height: '36px', backgroundColor: '#0f172a', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, boxShadow: '0 2px 4px rgba(15, 23, 42, 0.2)' }}>
                                                        <CheckCircle size={18} />
                                                    </button>
                                                    {/* Secundária: ícone outline */}
                                                    <button onClick={() => abrirModal(cand, 'remarcar')} title="Faltou / Remarcar integração" style={{ width: '36px', height: '36px', backgroundColor: '#fff', color: '#b45309', border: '1px solid #fde68a', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                        <RefreshCcw size={18} />
                                                    </button>
                                                    {/* Desistência: manda o candidato pro Banco de Talentos (funil status 8) */}
                                                    <button onClick={() => handleRegistrarDesistencia(cand)} title="Registrar desistência (envia ao Banco de Talentos)" style={{ width: '36px', height: '36px', backgroundColor: '#fff', color: '#e11d48', border: '1px solid #fecdd3', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                        <UserX size={18} />
                                                    </button>
                                                </div>
                                            ) : (
                                                <button onClick={() => handleDesfazerFinalizacao(cand.ID)} title="Retornar para Aguardando Início" style={{ width: '36px', height: '36px', backgroundColor: '#fff', color: '#64748b', border: '1px solid #e2e8f0', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, margin: '0 auto' }}>
                                                    <ArrowLeft size={18} />
                                                </button>
                                            )}
                                        </td>
                                    )}
                                </tr>
                            )) : <tr><td colSpan={canAction ? 6 : 5} style={{ padding: '40px', textAlign: 'center', color: '#94a3b8', fontWeight: '500' }}>Nenhum candidato nesta fila.</td></tr>}
                        </tbody>
                    </table>
                </div>

                {/* Paginação (50 por página) */}
                {totalPaginas > 1 && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px', borderTop: '1px solid #e2e8f0', backgroundColor: '#f8fafc' }}>
                        <span style={{ fontSize: '14px', color: '#64748b' }}>
                            Mostrando {indexPrimeiro + 1} a {Math.min(indexPrimeiro + ITENS_POR_PAGINA, aprovados.length)} de {aprovados.length}
                        </span>
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            <button onClick={() => setPaginaAtual(p => Math.max(p - 1, 1))} disabled={paginaAtual === 1} style={{ padding: '8px 12px', borderRadius: '8px', border: '1px solid #e2e8f0', backgroundColor: paginaAtual === 1 ? '#f1f5f9' : '#fff', color: paginaAtual === 1 ? '#cbd5e1' : '#0f172a', cursor: paginaAtual === 1 ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center' }}>
                                <ArrowLeft size={18} />
                            </button>
                            <span style={{ padding: '8px 16px', fontSize: '14px', fontWeight: 600, color: '#0f172a' }}>Página {paginaAtual} de {totalPaginas}</span>
                            <button onClick={() => setPaginaAtual(p => Math.min(p + 1, totalPaginas))} disabled={paginaAtual === totalPaginas} style={{ padding: '8px 12px', borderRadius: '8px', border: '1px solid #e2e8f0', backgroundColor: paginaAtual === totalPaginas ? '#f1f5f9' : '#fff', color: paginaAtual === totalPaginas ? '#cbd5e1' : '#0f172a', cursor: paginaAtual === totalPaginas ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', transform: 'rotate(180deg)' }}>
                                <ArrowLeft size={18} />
                            </button>
                        </div>
                    </div>
                )}
            </div>

            {/* ====== MODAL DINÂMICO ====== */}
            {isModalOpen && candSelecionado && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(15, 23, 42, 0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999, animation: 'fadeIn 0.2s' }}>
                    <div style={{ backgroundColor: '#fff', borderRadius: '16px', width: '100%', maxWidth: '600px', overflow: 'hidden', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)' }}>
                        
                        <div style={{ backgroundColor: modalMode === 'remarcar' ? '#b45309' : '#0f172a', padding: '24px', color: '#fff', transition: 'background-color 0.3s' }}>
                            <h3 style={{ margin: '0 0 8px 0', fontSize: '22px', fontWeight: '900' }}>
                                {modalMode === 'remarcar' ? 'Remarcar Integração (Falta)' : 'Agendar 1º Dia na Loja'}
                            </h3>
                            <p style={{ margin: 0, opacity: 0.9, fontSize: '15px' }}>
                                {modalMode === 'remarcar' ? 'Defina a NOVA data de integração para ' : 'Defina as datas do primeiro dia de '}
                                <strong>{candSelecionado.NOME_COMPLETO}</strong>.
                            </p>
                        </div>

                        <div style={{ padding: '32px' }}>
                            
                            {modalMode === 'remarcar' && (
                                <div style={{ backgroundColor: '#eff6ff', padding: '16px', borderRadius: '8px', borderLeft: '4px solid #3b82f6', marginBottom: '24px' }}>
                                    <label style={{...labelStyleModal, color: '#1e3a8a'}}><FileText size={14} style={{display: 'inline', marginBottom: '-2px'}}/> Nova Data da Integração ({integracaoData.diaSemanaIntegracao})</label>
                                    <input 
                                        type="date" 
                                        value={integracaoData.data_integracao} 
                                        onChange={e => setIntegracaoData({...integracaoData, data_integracao: e.target.value})} 
                                        style={{...inputStyleModal, border: '1px solid #bfdbfe'}} 
                                    />
                                    <p style={{ margin: '8px 0 0 0', fontSize: '12px', color: '#334155' }}>* Um e-mail avisando sobre a remarcação da Integração será enviado ao candidato.</p>
                                </div>
                            )}

                            {modalMode === 'finalizar' && (
                                <>
                                    <div style={{ marginBottom: '20px' }}>
                                        <label style={{...labelStyleModal, color: '#e11d48'}}>Loja de Atuação</label>
                                        <select
                                            value={integracaoData.loja}
                                            onChange={e => setIntegracaoData({...integracaoData, loja: e.target.value, endereco: getEnderecoLoja(e.target.value)})}
                                            style={{...inputStyleModal, border: '2px solid #e11d48'}}
                                        >
                                            <option value="">Selecione a Loja...</option><option value="ANV">ANV</option><option value="BVV">BVV</option><option value="FER">FER</option><option value="GTV">GTV</option><option value="MAL">MAL</option><option value="MOX">MOX</option><option value="PCI">PCI</option><option value="PCS">PCS</option><option value="RDP">RDP</option><option value="SED">SED</option><option value="SVV">SVV</option><option value="VEL">VEL</option><option value="VSH">VSH</option>
                                        </select>
                                    </div>

                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px' }}>
                                        <div>
                                            <label style={labelStyleModal}><CalendarPlus size={14} style={{display: 'inline', marginBottom: '-2px'}}/> Data do 1º Dia (Loja)</label>
                                            <input
                                                type="date"
                                                value={integracaoData.data_inicio}
                                                onChange={e => setIntegracaoData({...integracaoData, data_inicio: e.target.value})}
                                                style={inputStyleModal}
                                            />
                                            <p style={{ margin: '4px 0 0 0', fontSize: '11px', color: '#e11d48', fontWeight: 'bold' }}>Calculado base folga: {candSelecionado.FOLGA}</p>
                                        </div>
                                        <div>
                                            <label style={labelStyleModal}><Clock size={14} style={{display: 'inline', marginBottom: '-2px'}}/> Horário de Chegada</label>
                                            <input
                                                type="time"
                                                value={integracaoData.hora_inicio}
                                                onChange={e => setIntegracaoData({...integracaoData, hora_inicio: e.target.value})}
                                                style={inputStyleModal}
                                            />
                                        </div>
                                    </div>

                                    <div style={{ marginBottom: '32px' }}>
                                        <label style={labelStyleModal}><MapPin size={14} style={{display: 'inline', marginBottom: '-2px'}}/> Endereço da Loja {integracaoData.loja ? `(${integracaoData.loja})` : ''}</label>
                                        <textarea
                                            value={integracaoData.endereco}
                                            onChange={e => setIntegracaoData({...integracaoData, endereco: e.target.value})}
                                            rows="2"
                                            placeholder="Selecione a loja para preencher automaticamente ou digite o endereço..."
                                            style={{ ...inputStyleModal, resize: 'vertical' }}
                                        />
                                    </div>
                                </>
                            )}

                            <hr style={{ border: 'none', borderTop: '1px solid #e2e8f0', marginBottom: '24px' }}/>

                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                                <button onClick={() => setIsModalOpen(false)} style={{ padding: '12px 24px', borderRadius: '8px', border: '2px solid #e2e8f0', backgroundColor: '#fff', color: '#64748b', fontWeight: '800', cursor: 'pointer' }}>
                                    Cancelar
                                </button>
                                <button onClick={handleSalvarModal} style={{ padding: '12px 24px', borderRadius: '8px', border: 'none', backgroundColor: '#10b981', color: '#fff', fontWeight: '800', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', boxShadow: '0 4px 6px rgba(16, 185, 129, 0.2)' }}>
                                    <CheckCircle size={18} /> {modalMode === 'remarcar' ? 'Confirmar Remarcação e Enviar' : 'Finalizar Processo e Enviar'}
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            )}
            {/* ====== SUPER POP-UP DE AUTOMAÇÃO ====== */}
            {automacaoModal.isOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(15, 23, 42, 0.85)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 99999, padding: '20px', animation: 'fadeIn 0.2s' }}>
                    <div style={{ backgroundColor: '#fff', borderRadius: '24px', width: '100%', maxWidth: '700px', padding: '48px 32px', textAlign: 'center', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)' }}>
                        
                        <div style={{ backgroundColor: '#fef3c7', width: '96px', height: '96px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px auto' }}>
                            <MessageCircle size={48} color="#d97706" />
                        </div>
                        
                        <h2 style={{ fontSize: '32px', fontWeight: '900', color: '#0f172a', marginBottom: '16px' }}>
                            {automacaoModal.titulo}
                        </h2>
                        
                        <p style={{ fontSize: '18px', color: '#475569', marginBottom: '40px', lineHeight: '1.6' }}>
                            {automacaoModal.mensagem}
                        </p>
                        
                        <div style={{ display: 'flex', gap: '20px', justifyContent: 'center' }}>
                            <button 
                                onClick={() => automacaoModal.onCancel()} 
                                style={{ padding: '16px 24px', fontSize: '18px', borderRadius: '12px', border: '2px solid #e2e8f0', backgroundColor: '#f8fafc', color: '#64748b', fontWeight: '800', cursor: 'pointer', transition: 'all 0.2s', flex: 1 }}
                            >
                                Não, apenas salvar
                            </button>
                            
                            <button 
                                onClick={() => automacaoModal.onConfirm()} 
                                style={{ padding: '16px 24px', fontSize: '18px', borderRadius: '12px', border: 'none', background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', color: '#fff', fontWeight: '900', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', boxShadow: '0 10px 15px -3px rgba(16, 185, 129, 0.3)', flex: 1 }}
                            >
                                <CheckCircle size={24} /> Sim, Enviar Mensagem
                            </button>
                        </div>

                        <button 
                            onClick={() => setAutomacaoModal({ ...automacaoModal, isOpen: false })} 
                            style={{ marginTop: '32px', background: 'none', border: 'none', color: '#94a3b8', textDecoration: 'underline', cursor: 'pointer', fontSize: '15px', fontWeight: '600' }}
                        >
                            Cancelar tudo e fechar
                        </button>

                    </div>
                </div>
            )}
        </div>
        
    );
};

export default ProcessoSeletivoAprovados;